<div style="display: flex; " (click)="openDialog();" [formGroup]="formItemDropdownGroup">
    <p-select
      class="personalized-dropdown"
      [style]="{'border-top-right-radius':'0px', 'border-bottom-right-radius':'0px'}"
      [pTooltip]="items.length> 0 ? items[0].description : ''"
      tooltipPosition="top"
      [fitContent]="true"
      [ngClass]="className"
      emptyMessage="No hay registros"
      placeholder="Seleccione opción"
      [options]="items"
      formControlName="itemFormControl"
      optionLabel="description"
      [style]="{'width':'100%'}"
      optionValue="code"
      [showClear]="true"
      [readonly]="true"
      (click)="stopPropagation($event)"
      dropdownIcon="none"
      (onClear)="clearItems();">
    </p-select>
    <p-button 
      [style]="{'border-top-left-radius':'0px', 'border-bottom-left-radius':'0px','color':'white', 'background':'var(--color-primario)'}"
      icon="bx bx-search"
      [outlined]="false"
      [disabled]="disabledPropControl"
    >
    </p-button>
</div>


